/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Benefits_Cancel_AnytimeInputs */

const en_mobile_benefits_cancel_anytime = /** @type {(inputs: Mobile_Benefits_Cancel_AnytimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel anytime — money back guarantee`)
};

const es_mobile_benefits_cancel_anytime = /** @type {(inputs: Mobile_Benefits_Cancel_AnytimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancela cuando quieras — garantía de devolución`)
};

/**
* | output |
* | --- |
* | "Cancel anytime — money back guarantee" |
*
* @param {Mobile_Benefits_Cancel_AnytimeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_benefits_cancel_anytime = /** @type {((inputs?: Mobile_Benefits_Cancel_AnytimeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Benefits_Cancel_AnytimeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_benefits_cancel_anytime(inputs)
	return en_mobile_benefits_cancel_anytime(inputs)
});